import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useCallback } from 'react';
import { setCreateGameBuyInRange } from '../../../redux/actions/createGameActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { ALL_BUY_IN_RANGES, ALL_CREATE_ROOM_TYPE_PROPERTIES, BUY_IN_RANGE_LABELS } from '../../../types/sharedTypes';
export const BuyInRangeControlContainer = () => {
    const dispatch = useAppDispatch();
    const buyInRange = useAppSelector((state) => state.createGame.buyInRange);
    const roomType = useAppSelector((state) => state.createGame.roomType);
    const onChangeBuyInRange = useCallback((event) => {
        dispatch(setCreateGameBuyInRange(ALL_BUY_IN_RANGES[Number(event.target.value)]));
    }, [dispatch]);
    if (!ALL_CREATE_ROOM_TYPE_PROPERTIES[roomType].hasBuyinRangeControl) {
        return null;
    }
    return (_jsxs(FormControl, { variant: 'outlined', children: [_jsx(InputLabel, { children: "Range" }), _jsx(Select, { "data-testid": 'create-game-buy-in-range-select', value: `${ALL_BUY_IN_RANGES.indexOf(buyInRange)}`, label: 'Range', onChange: onChangeBuyInRange, children: ALL_BUY_IN_RANGES.map((buyInRange, i) => (_jsx(MenuItem, { value: i, children: BUY_IN_RANGE_LABELS[buyInRange] }, i))) })] }));
};
